import { NFCAction, nfcReducer, NFCState } from '../nfc/reducer';
import { ZebraAction, zebraReducer, ZebraState } from '../zebra/reducer';

export interface CashierState {
  nfcScanner?: NFCState;
  zebraPrinter?: ZebraState;
}

export interface BaseCashierAction {
  source?: 'nfc' | 'zebra';
}

interface InitNFCAction extends BaseCashierAction {
  type: 'INIT_NFC';
  payload: NFCState;
}

interface InitZebraAction extends BaseCashierAction {
  type: 'INIT_ZEBRA_PRINTER';
  payload: ZebraState;
}

interface ReloadAction extends BaseCashierAction {
  type: 'RELOAD';
}

export type CashierAction =
  | InitNFCAction
  | NFCAction
  | InitZebraAction
  | ZebraAction
  | ReloadAction;

export function cashierReducer(state: CashierState, action: CashierAction): CashierState {
  if (action.source === 'zebra' && state.zebraPrinter) {
    return {
      ...state,
      zebraPrinter: zebraReducer(state.zebraPrinter, action as ZebraAction),
    };
  }

  if (action.source === 'nfc' && state.nfcScanner) {
    return {
      ...state,
      nfcScanner: nfcReducer(state.nfcScanner, action as NFCAction),
    };
  }

  switch (action.type) {
    case 'INIT_NFC': {
      return {
        ...state,
        nfcScanner: action.payload,
      };
    }

    case 'INIT_ZEBRA_PRINTER': {
      return {
        ...state,
        zebraPrinter: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
